import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import RaisedContainer from '../../../../components/RaisedContainer';
import { Typography, Loader } from 'kangarootime-ui';
import { Collapse } from '@material-ui/core';
import './InformationCard.css';

const InformationCard = ({ title, color, showExpandButton, isLoading, ...props }) => {
  const isCollapsible = Boolean(showExpandButton);
  const [showExpanded, setExpanded] = useState(false);

  return (
    <RaisedContainer style={{ borderLeft: `4px solid ${color}` }}>
      <div className='information-card flex-columns'>
        <Typography type='header'>{title}</Typography>
        <Loader loading={isLoading}>
          <Fragment>
            <div className='flex-1' style={{ margin: '4px 4px 4px 0px' }}>
              <Collapse in={isCollapsible ? showExpanded : true} style={{ width: '100%' }}>
                { props.children }
              </Collapse>
            </div>
            { showExpandButton &&
              <div className='flex' style={{ justifyContent: 'flex-end', cursor: 'pointer' }} onClick={() => setExpanded(!showExpanded)}>
                <Typography type='header' style={{ fontSize: 12, fontWeight: 600, color }}>Expand</Typography>
              </div>
            }
          </Fragment>
        </Loader>
      </div>
    </RaisedContainer>
  );
};

InformationCard.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  showExpandButton: PropTypes.bool,
  isLoading: PropTypes.bool
};

export default InformationCard;
